export default __webpack_public_path__ + "41d4dd83d7ef0b5e60ab344446289c0e.png";